$( document ).on('turbolinks:load', () => {
  $('#dte-transferred-btn').on('click', () => {
    $('#document-table').addClass('d-none')
    $('.loader').fadeIn();
  })
})